module.exports = __webpack_public_path__ + "img/h5img8.50063139.png";